import type { TextEditor } from '@botco/library';

import { DEFAULT_DISABLED_ATTRS } from './attributeChipConfig';

export type AttributeTextEditorProps = Omit<
  React.ComponentProps<typeof TextEditor.Editor>,
  'editor' | 'onChange'
> & {
  agentId: number;
  initialValue: string;
  onChange?: (value: string) => void;
  additionalAttributes?: string[];
  /**
   * Array of attribute names that should be enabled even if they are configured as disabled by default
   * Example: ['_transcript'] will enable the _transcript attribute
   */
  enabledAttributes?: DEFAULT_DISABLED_ATTRS[];
};

export const ATTRIBUTE_MATCH_REGEX = /^\$\{([a-z_][a-z0-9_]*)/;
